const root = "/orders";

export const returnToOrderParam = "orderId";

export function withReturnToOrder(path: string, odNumber: string | null) {
  return odNumber ? `${path}?${new URLSearchParams({ [returnToOrderParam]: odNumber })}` : path;
}

export const orderRoutes = {
  root: root,
  detail: (odNumber: string) => ({
    root: `${root}/${odNumber}`,
    history: `${root}/${odNumber}/history`,
    document: `${root}/${odNumber}/document`,
  }),
};
